import { Grid, InputLabel } from '@material-ui/core';
import React, { useState } from 'react';
import { DatePicker, PrimaryButton, SecondaryButton, SingleSelect } from '../../../../../../Core/Controls';
import { Alert } from '@material-ui/lab';
import { postJobStepSignOff, postJobWheelsRemoved } from '../../../../../../Core/Services/InternalUser/ControllerService/jobStepperService';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const WheelRemovalConfirmation = ({ handleNext, jobDetails, isEngineer, isDisabled, isServiceAgent, onClose, pullData, handleSteps }) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();

    const [btnLoader, setBtnLoader] = useState(false);

    const history = useHistory();
    const [state, setState] = useState({
        completionDate: moment().format('YYYY-MM-DD')
    });

    const handleSubmit = async (condition) => {
        if (!state.completionDate) {
            showToastWarning('Completion date cannot be empty');
            return false;
        }
        setBtnLoader(true);
        const data = {
            JobID: jobDetails.jobID,
            WheelsRemoved: condition
        };
        let res = await postJobWheelsRemoved(data);
        if (res.success) {
            showToastSuccess(res.data.message);
            setBtnLoader(false);
            onClose();
            pullData();
            handleSteps(3);
        } else {
            showToastError(res.message);
            setBtnLoader(false);
        }
    };

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };
    return (
        <div style={{ padding: 10 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="error">
                        Please click YES button if you removed wheels as part of the job otherwise click NO button. Clicking YES will force you to set wheel
                        remove and torque details before job can be signed off
                    </Alert>
                </Grid>

                {/* {(isEngineer || isServiceAgent) && isDisabled && ( */}
                <Grid item xs={6}>
                    <PrimaryButton onClick={() => handleSubmit(true)} isBtnLoader={btnLoader}>
                        YES
                    </PrimaryButton>
                </Grid>
                <Grid item xs={6}>
                    <SecondaryButton onClick={() => handleSubmit(false)} isBtnLoader={btnLoader}>
                        NO
                    </SecondaryButton>
                </Grid>
                {/* )} */}
            </Grid>
        </div>
    );
};

export default WheelRemovalConfirmation;
